export default "assets/images/9ac6d81f417d6a5626b7c8d5a087c32b.png";